"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const store_1 = require("client/modules/inventory-order/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const styles = (theme) => core_1.createStyles({
    root: {
        display: "flex",
        flexWra: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    }
});
let DistributorDropDownOverride = class DistributorDropDownOverride extends react_1.Component {
    constructor() {
        super(...arguments);
        this.optionSelected = "";
        this.distributorOptions = [];
        this.distributorInventories = [];
        this.handleSelect = (event) => {
            const selection = {
                distributorSelected: event.target.value,
                inventoryId: this.props.inventory.id
            };
            // console.log("selection is", selection);
            const action = this.props.onSelect && this.props.onSelect(selection);
            if (action !== "do not update") {
                this.optionSelected = event.target.value;
            }
        };
        this.renderMenuItems = () => this.availableOptions.length
            ? this.availableOptions.map((distributorOption, index) => (React.createElement(material_ui_1.MenuItem, { key: index, value: distributorOption.value }, distributorOption.label)))
            : [];
    }
    async componentWillMount() {
        this.optionSelected = this.props.selectedDistributor
            ? this.props.selectedDistributor
            : "";
    }
    async componentDidMount() {
        const { inventory, siteId } = this.props;
        this.distributorInventories = await store_1.inventoryOrderStore.loadDistributorInventoriesBySite(siteId, inventory.id);
    }
    get availableOptions() {
        const { id: inventoryId } = this.props.inventory;
        const { siteDistributors = [] } = store_1.inventoryOrderStore;
        if (!siteDistributors.length) {
            return [];
        }
        return (this.distributorInventories.map(({ distributor }) => ({
            id: distributor.id,
            label: distributor.distributor,
            value: distributor.distributor // changed from distributorInventory to distrbutorInventory.distributorName
        })) || []);
    }
    render() {
        const { classes } = this.props;
        return (React.createElement(material_ui_1.FormControl, { className: classes.formControl },
            React.createElement(material_ui_1.Select, { value: this.optionSelected || this.props.selectedDistributor, onChange: this.handleSelect, 
                // onChange={this.props.handleDistributorSelectOverride}
                name: "distributor" },
                React.createElement(material_ui_1.MenuItem, { value: this.optionSelected || "", disabled: true }, this.optionSelected || this.props.selectedDistributor
                    ? this.props.selectedDistributor
                    : "Select distributor"),
                this.renderMenuItems())));
    }
};
__decorate([
    mobx_1.observable
], DistributorDropDownOverride.prototype, "optionSelected", void 0);
__decorate([
    mobx_1.observable
], DistributorDropDownOverride.prototype, "distributorOptions", void 0);
__decorate([
    mobx_1.observable
], DistributorDropDownOverride.prototype, "distributorInventories", void 0);
DistributorDropDownOverride = __decorate([
    mobx_react_1.observer
], DistributorDropDownOverride);
exports.default = core_1.withStyles(styles)(DistributorDropDownOverride);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/components/distributor-drop-down-override/distributor-drop-down-override.tsx
// module id = 3601
// module chunks = 0